<template>
  <div class="adesao">
      <iframe src="https://stillos.com.br/sac" class="iframe"></iframe>
  </div>
</template>

<script>
export default {
  name: 'gallery',
}
</script>


<style scoped lang="scss">
.adesao{
    width: 1415px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    .iframe {
        width: 930px;
        height: 100%;
        border: none;
        transform: scale(1.5);
        margin-left: 195px;
        margin-top: 270px;
    }
}
</style>